import React from 'react';
import { View, StyleSheet, Pressable } from 'react-native';
import tw from '../../styles/twrnc-config';
import { useSelector, useDispatch } from "react-redux";
import Text from '../../components/Text';
import { useRoute } from '@react-navigation/native';
import { subeImagenesFirmasData, setImagenesFirmadas } from '../../store/slices/imagenes';

const FooterFirma = ({ navigation, Contrato, numeroDoc }) => {
  const [error, setError] = React.useState<string | null>(null);
  const ImagenesData = useSelector(state => state.imagenes);
  const firmasData = useSelector(state => state.firmas);
  const contratoData = useSelector(state => state.selectedDoc);
  const dispatch = useDispatch();
  const documentosData = Contrato.documentos;

  const verificarFirmasCompletas = () => {
    const firmasUrls = firmasData.firmasUrls || []; 

    // Verificar que todos los documentos tengan una firma correspondiente en firmasUrls
    for (let i = 0; i < numeroDoc; i++) {
      if (!documentosData[i].fechaFirma && !firmasUrls[i]) {
        // Si encontramos un documento sin firma, regresamos false
        return false;
      }
    }

    // Si todos los documentos tienen firma, regresamos true
    if (firmasData.firmasUrls.length === 0){
      dispatch( setImagenesFirmadas({imagenesFirmadas: true}) );
    }
    return true;
  };

  const goToAltaDocumentos = async () => {
    if (verificarFirmasCompletas()) {
      console.log("imagenesFirmadas antes del dispatch: ", ImagenesData.imagenesFirmadas);
      if(!ImagenesData.imagenesFirmadas){
        const result = await dispatch(subeImagenesFirmasData(firmasData.firmasUrls, contratoData.idActivacion, contratoData.id_empresa));
        if(result.success){
          navigation.navigate('AltaDocumentosScreen.Index');
        }else{
          setError(result.message || "Error al subir las firmas. Por favor, intente nuevamente.");
          //alert("Error al subir las firmas. Por favor, intente nuevamente.");
        }
      } else {
        // Ya están las imágenes firmadas, navegar directamente
        navigation.navigate('AltaDocumentosScreen.Index');
      }
    } else {
      alert("Por favor termina de firmar todos los documentos");
    }
  };

  const firmasCompletas = verificarFirmasCompletas();

  return (
    <View style={[tw`w-full pr-5 pl-5 pb-6 pt-6 shadow-lg bg-white`]}>
      {
        error && (
          <Text style={tw`text-red-500 text-center mb-3`}>{error}</Text>
        )
      }
      <View style={tw`flex-row justify-center items-center`}>
        <Pressable
          style={[tw`flex-1 py-3 rounded-full`, firmasCompletas ? tw`bg-primary` : tw`bg-buttonInac`, styles.buttonFooter]}
          onPress={goToAltaDocumentos}
        >
          <Text style={[tw`text-center text-xl`, firmasCompletas ? tw`text-white` : tw`text-textButton`]}>
            Continuar
          </Text>
        </Pressable>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  buttonFooter: {
    width: 150,
    height: 55,
  },
});

export default FooterFirma;
